import AppStoreButtonIcon from 'assets/app-store-button.svg?react';

const appStoreUrl = `https://apps.apple.com/us/app/${String(import.meta.env.VITE_APP_IOS_APPSTORE_ID)}`;

const AppStoreButton = () => (
  <a href={appStoreUrl}>
    <AppStoreButtonIcon />
  </a>
);

export default AppStoreButton;
